<div class="header">
  <div class="left-icons">
    <button (click)="onClose()" mat-icon-button aria-label="Back">
      <mat-icon title="Back">arrow_back</mat-icon>
    </button>
  </div>
  <div class="title">
    @if (!isNew) {
      Edit delivery
    }
    @if (isNew) {
      Add delivery
    }
  </div>
  <div class="right-icons">
    <button type="button" class="mat-inline-button" mat-button color="primary" (click)="saveAll()">Done</button>
  </div>
</div>

<div class="body">
  @if (initialized) {
    <!-- Biditem section -->
    @if (biditem) {
      <section>
        <div class="mat-headline-5">{{biditem?.item}}</div>
        <div>{{biditem.description}}</div>
      </section>
    }
    <!-- /Biditem section -->
    <!-- Material section -->
    @if (material) {
      <section>
        <div class="mat-headline-5">{{material?.name}}</div>
        <div class="caption">
          <div>Total received: {{rmd?.totalReceived || 0}}</div>
          <div>On-hand quantity: {{rmd?.totalUsed || 0}}</div>
          @if (materialBiditems?.length) {
            <div>
              Bid items:
              @for (bi of materialBiditems; track bi) {
                <span class="comma-separated">{{bi.item}}</span>
              }
            </div>
          }
        </div>
      </section>
    }
    <!-- /Material section -->
    <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{ 'li': headerItem }">
    </ng-container>
    <!-- Line items -->
    @if (lineItems.length) {
      <mat-accordion class="line-items">
        @for (li of lineItems; track li) {
          <mat-expansion-panel [expanded]="li._id === selectedItem?._id">
            <mat-expansion-panel-header (click)="selectLineItem(li)">
              <div class="header-row">
                <span>
                  @if ((!li._inputForm.valid && !li._inputForm.pristine)) {
                    <mat-icon color="warn">error</mat-icon>
                  }
                  <ng-container>{{li?.material?.name}}</ng-container>
                  @if (li.getFieldValueSummary(fields)) {
                    <span class="mat-caption"
                      >&nbsp;({{li.getFieldValueSummary(fields)}})
                    </span>
                  }
                </span>
                <div class="icons">
                  <!-- More menu -->
                  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="delete(li)">
                      <mat-icon>delete</mat-icon>
                      <span>Remove delivery</span>
                    </button>
                  </mat-menu>
                  <!-- /More menu -->
                </div>
              </div>
            </mat-expansion-panel-header>
            <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{'li': li}">
            </ng-container>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
    <!-- /Line items -->
    <!-- Delete all items -->
    <section>
      <br />
      <button type="button" class="mat-inline-button" mat-button color="primary" (click)="deleteAll()">
        <mat-icon>delete</mat-icon> Delete delivery
      </button>
    </section>
    <!-- /Delete all items -->
    <ng-container [ngTemplateOutlet]="readOnlyToolbarItems" [ngTemplateOutletContext]="{'li': headerItem}"></ng-container>
  }
</div>

@if (initialized) {
  <div class="footer">
    @if (selectedItem) {
      <app-report-item-toolbar [lineItem]="selectedItem" [project]="project"
      (changed)="onLineItemChange($event)"></app-report-item-toolbar>
    }
  </div>
}


<ng-template #SingleForm let-li="li">
  <form [formGroup]="li._inputForm">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
    </section>

    @if (!material && li._isHeader) {
      <section>
        <div class="mat-body-2">Quantity@if (isRequired(li._inputForm.controls.quantity)) {
          <span style="color: red;"
          >*</span>
        }</div>
        <mat-form-field>
          <input matInput autocomplete="off" formControlName="quantity" [errorStateMatcher]="matcher" />
          @if (biditem?.uom) {
            <span class="mat-body-2" matSuffix>({{biditem?.uom}})</span>
          }
          @if (li._inputForm.controls.quantity.hasError('required')) {
            <mat-error>
              This field is required
            </mat-error>
          }
          @if (li._inputForm.controls.quantity.hasError('error')) {
            <mat-error>
              {{li._inputForm.controls.quantity.errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </section>
    }

    <section class="custom-fields">

      @if (material || (!li._isHeader && captureLineItems)) {
        <section class="width-50">
          <div class="mat-body-2">Received@if (isRequired(li._inputForm.controls.received)) {
            <span style="color: red;"
            >*</span>
          }</div>
          <mat-form-field>
            <input matInput autocomplete="off" formControlName="received" [errorStateMatcher]="matcher" />
            @if (material?.uom || li?.material?.uom) {
              <span class="mat-body-2" matSuffix>({{material?.uom ||
              li?.material?.uom}})</span>
            }
            @if (li._inputForm.controls.received.hasError('required')) {
              <mat-error>
                This field is required
              </mat-error>
            }
            @if (li._inputForm.controls.received.hasError('error')) {
              <mat-error>
                {{li._inputForm.controls.received.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        </section>
      }

      <!-- capture lineitems -->
      @if (captureLineItems && li._isHeader) {
        <section class="width-100">
          <div class="row">
            <div>
              <mat-form-field>
                <mat-label>Add material</mat-label>
                <mat-select #materialDropdown>
                  @for (m of materials; track m) {
                    <mat-option [value]="m" [disabled]="duplicateLineItem(m)">
                      {{m.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="icons">
              <button type="button" mat-icon-button [disabled]="!materialDropdown.value"
                (click)="addLineItem(null, materialDropdown.value)">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </section>
      }
      <!-- /capture lineitems -->

      @if (!(captureLineItems && li._isHeader)) {
        @for (field of fields; track field) {
          <app-field-input [field]="field" [form]="li._inputForm" [matcher]="matcher"
          [class]="getWidth(field)"></app-field-input>
        }
      }
    </section>
    <div style="clear: both"></div>

  </form>
  @if (!li._isHeader) {
    <ng-container [ngTemplateOutlet]="readOnlyToolbarItems" [ngTemplateOutletContext]="{'li': li}"></ng-container>
  }
</ng-template>



<ng-template #readOnlyToolbarItems let-li="li">
  @if (li.pictures.length) {
    <section>
      <div class="mat-body-2">Pictures:</div>
      <div class="preview-list">
        @for (pic of li.pictures; track pic) {
          <div>
            <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, li.pictures, pic)" />
          </div>
        }
      </div>
    </section>
  }

  @if (li.annotations.length) {
    <section>
      <div class="mat-body-2">Annotations:</div>
      <div class="preview-list">
        @for (ann of li.annotations; track ann) {
          <div>
            <img [src]="ann.getThumbnail()" class="link" />
          </div>
        }
      </div>
    </section>
  }

  @if (!li.location.isEmpty) {
    <section>
      <div class="mat-body-2">Location:</div>
      <div>
        <app-location-picker [isDialog]="false" [latitude]="li.location.lat" [longitude]="li.location.lng" height="100px"
        [readOnly]="true"></app-location-picker>
      </div>
    </section>
  }

  @if (li.comment) {
    <section>
      <div class="mat-body-2">Comment:</div>
      <mat-form-field appearance="outline">
        <textarea matInput rows="5" [value]="li.comment" [disabled]="true"></textarea>
      </mat-form-field>
    </section>
  }
</ng-template>